import './styles/globals.scss';

// Sentry initialization (early in app lifecycle)
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	environment: import.meta.env.VITE_SENTRY_ENV,
	// Release is optional but recommended for source maps and deploys; provided by CI
	release: import.meta.env.VITE_SENTRY_RELEASE,
	// Optional tunnel to bypass ad blockers; must be proxied by your domain/reverse proxy
	tunnel: import.meta.env.VITE_SENTRY_TUNNEL,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
	],
	// Sensible defaults: high sampling in dev, lower in prod can be set via .env files later if needed
	tracesSampleRate: 1,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1,
});

const root = ReactDOM.createRoot(
	// eslint-disable-next-line unicorn/prefer-query-selector
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>
);
